import React from 'react';
import { Link } from 'react-router-dom';
import { SocialMediaLinks } from './SocialMediaWidget';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--surface)] border-t border-[var(--border)]" data-testid="footer">
      <div className="page-padding py-12">
        <div className="max-w-7xl mx-auto">
          {/* Main Footer Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-12">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1 lg:col-span-2">
              <Link to="/" className="inline-block mb-4">
                <span className="text-3xl font-teko font-semibold text-gradient">Supremics</span>
              </Link>
              <p className="text-sm text-[var(--text-secondary)] mb-4 max-w-xs">
                The ultimate platform for comic creators and readers. Discover, create, and share amazing stories.
              </p>
              {/* Social Links */}
              <SocialMediaLinks />
            </div>

            {/* Explore */}
            <div>
              <h4 className="font-teko text-lg mb-4 text-[var(--foreground)]">Explore</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/browse" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">Browse Comics</Link></li>
                <li><Link to="/creators" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">Creators</Link></li>
                <li><Link to="/collections" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">Collections</Link></li>
                <li><Link to="/leaderboard" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">Leaderboard</Link></li>
                <li><Link to="/prizes" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">Weekly Prizes</Link></li>
              </ul>
            </div>

            {/* Creators */}
            <div>
              <h4 className="font-teko text-lg mb-4 text-[var(--foreground)]">For Creators</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/pricing" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">Pricing</Link></li>
                <li><Link to="/creator-application" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">Become a Creator</Link></li>
                <li><Link to="/ai-tools" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">AI Studio</Link></li>
                <li><Link to="/creator/analytics" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">Analytics</Link></li>
                <li><Link to="/creator/earnings" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">Earnings</Link></li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h4 className="font-teko text-lg mb-4 text-[var(--foreground)]">Support</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/customer-service" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">Customer Service</Link></li>
                <li><Link to="/about" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">About Us</Link></li>
                <li><Link to="/privacy" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">Privacy Policy</Link></li>
                <li><Link to="/terms" className="text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">Terms of Service</Link></li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-[var(--border)] flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-[var(--text-secondary)]">
              © {currentYear} Supremics. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm text-[var(--text-secondary)]">
              <Link to="/privacy" className="hover:text-[var(--primary)] transition-colors">Privacy</Link>
              <Link to="/terms" className="hover:text-[var(--primary)] transition-colors">Terms</Link>
              <Link to="/customer-service" className="hover:text-[var(--primary)] transition-colors">Help</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
